<template>
  <transition-group
    class="notifications-list"
    :class="$style['notifications-list']"
    tag="ul"
    name="toast-list"
  >
    <li v-for="{ id, message, type } in messages" :key="id || message">
      <MessageBox
        :type
        :role="'alert' /* JAWS doesn't always announce 'status' */"
        :class="[$style.notification, { [$style.error]: isError(type) }]"
      >
        {{ message }}
      </MessageBox>
    </li>
  </transition-group>
</template>

<script>
import { mapState } from "pinia";

import { useToastStore } from "@/stores/toast";

import MessageBox from "./MessageBox.vue";

export default {
  components: { MessageBox },
  computed: {
    ...mapState(useToastStore, ["messages"]),
  },
  methods: {
    isError(type) {
      return type === "error";
    },
  },
};
</script>

<style lang="scss" module>
@use "@/styles/layers";
@use "@/colors" as c;

.notifications-list {
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  list-style-type: none;
  max-height: 100vh;
  min-width: 650px;
  position: fixed;
  right: 0;
  top: 6%;
  transition: all 1s;
  z-index: layers.$toast;

  li {
    flex: 0;
    margin: 0.5rem;
    transition: all 1s;
  }

  .notification {
    width: 512px;
    box-shadow: 0 2px 20px rgb(0 0 0 / 18%);
    box-sizing: initial;
    background-color: c.$white;
    border-left: 8px solid c.$brand-success;

    &.error {
      border-left: 8px solid c.$brand-danger;
    }
  }
}
</style>

<style lang="scss">
/* Vue 3 renamed -enter to -enter-from */
.toast-list-enter-from,
.toast-list-leave-to {
  opacity: 0;
}

.toast-list-enter-from {
  translate: 50%;
}

.toast-list-leave-to {
  translate: 0 -100%;
}
</style>
